<!-- Component can be used in microscope and periscope -->
<template>
  <td :class="{ errored: error }">
    <slot />
  </td>
</template>

<script setup lang="ts">
defineProps<{
  error?: boolean
}>()
</script>

<style lang="scss" scoped>
td {
  border: 1px solid var(--color-border-default);

  &.errored {
    background-color: var(--color-danger-subtle);
  }
}
</style>
